import React from "react";


export const LabelCompo = ({label,style,onClick,className}) => {
  return <label style={style} onClick={onClick} id="demo-simple-select-helper-label" className={className}>
             {label}   </label>;
}